import {
  ActionIcon,
  Box,
  Button,
  Divider,
  FileButton,
  Flex,
  Menu,
  rem,
  ScrollArea,
  Table,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import {
  IconArrowBackUp,
  IconCheck,
  IconDatabaseX,
  IconDownload,
  IconFileUpload,
  IconListSearch,
  IconTrash,
} from "@tabler/icons-react";
import cx from "clsx";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useRef, useState } from "react";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import classes from "../../../Styles/TableScrollArea.module.css";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import * as XLSX from "xlsx";
import { modals } from "@mantine/modals";

const TableProduct = ({
  dataProductSelect,
  selectData,
  isEnable,
  isDetail,
}: {
  dataProductSelect: any[];
  selectData: any;
  isEnable: any;
  isDetail?: boolean;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [dataProduct, setDataProduct] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);

  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [scrolled, setScrolled] = useState(false);
  const resetRef = useRef<() => void>(null);

  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 100,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <Flex justify={"space-between"} gap={"md"}>
            <ActionIcon
              variant="light"
              color="red"
              onClick={() => {
                const dataDelete = dataProductSelect.filter(
                  (item) => item.itemCode !== row.original.itemCode
                );

                selectData(dataDelete);
              }}
            >
              <IconTrash size={20} />
            </ActionIcon>
          </Flex>
        ),
      },
    ],
    [dataProductSelect]
  );

  const getColumnVisibility = () => {
    if (isDetail) {
      return {
        id: false,
        action: false,
      };
    } else {
      return {
        id: false,
        action: true,
      };
    }
  };

  const filterDuplicateItems = (dataArray: any) => {
    const seen = new Set();

    return dataArray.filter((item: any) => {
      if (seen.has(item.itemCode)) {
        return false;
      }

      seen.add(item.itemCode);
      return true;
    });
  };

  const handleFileUpload = (file: File) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const binaryData = event.target?.result;
      const workbook = XLSX.read(binaryData, { type: "binary" });

      // Lấy sheet đầu tiên
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json<any>(sheet);
      const mappedData: any[] = jsonData.map((row: any, index: number) => ({
        itemCode: row["Mã sản phẩm"] || null,
        itemName: row["Tên sản phẩm"] || null,
      }));

      selectData((item: any) => filterDuplicateItems([...mappedData, ...item]));
    };

    reader.readAsBinaryString(file);
  };

  const modalsDeleteAll = () => {
    modals.openConfirmModal({
      size: "auto",
      title: <Title order={5}>Xóa tất cả !</Title>,
      children: (
        <Box>
          <Text fw={500} size="18px" mt={10}>
            Bạn có chắc muốn xóa tất cả sản phẩm không ?
          </Text>
          <Flex justify={"center"} gap={"md"} mt={10}>
            <Button
              leftSection={<IconArrowBackUp />}
              color="gray"
              variant="outline"
              onClick={() => modals.closeAll()}
            >
              Hủy
            </Button>
            <Button
              leftSection={<IconCheck />}
              color="red"
              variant="outline"
              onClick={() => {
                selectData([]);
                modals.closeAll();
              }}
            >
              Xác nhận
            </Button>
          </Flex>
        </Box>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchDataProduct = async () => {
    let url = `/api/v1/TblDmItemCategoryCombination/get-list?Skip=0&Take=50&KeySearch=${keySearch}`;

    const res = await repositoryDelivery.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const result = res.data;
      setDataProduct(result);
    } else {
      setDataProduct([]);
    }
  };

  useEffect(() => {
    if (keySearch.length > 2) {
      fetchDataProduct();
    } else {
      setDataProduct([]);
    }
  }, [keySearch]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (585 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data: dataProductSelect,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    enableGlobalFilter: true,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.itemCode?.toString(),
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    positionGlobalFilter: "left",
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    // manualPagination: true,
    renderToolbarInternalActions: ({ table }) => (
      <>
        {!isDetail ? (
          <>
            <Flex align={"center"} gap={"xs"}>
              <Menu trigger="hover" withinPortal>
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã sản phẩm hoặc tên sản phẩm (Thêm sản phẩm)"
                    leftSection={<IconListSearch size={16} color="#15aabf" />}
                    defaultValue={keySearch}
                    onChange={(e) => setKeySearch(e.currentTarget.value)}
                    disabled={isEnable}
                    size="xs"
                    w={300}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={400}
                    onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
                  >
                    <Table striped highlightOnHover w={800}>
                      <Table.Thead
                        className={cx(classes.header, {
                          [classes.scrolled]: scrolled,
                        })}
                      >
                        <Table.Tr>
                          <Table.Th></Table.Th>
                          <Table.Th>Mã sản phẩm</Table.Th>
                          <Table.Th>Tên sản phẩm</Table.Th>
                        </Table.Tr>
                      </Table.Thead>
                      <Table.Tbody>
                        {dataProduct && dataProduct.length > 0 ? (
                          dataProduct.map((item, index) => (
                            <Table.Tr key={index}>
                              <Table.Td w={85} ta={"center"}>
                                <Button
                                  onClick={() => {
                                    selectData(() => [
                                      ...dataProductSelect,
                                      {
                                        itemCode: item.itemCode,
                                        itemName: item.itemName,
                                      },
                                    ]);
                                  }}
                                  disabled={
                                    dataProductSelect.filter(
                                      (i) => i.itemCode === item.itemCode
                                    ).length > 0
                                  }
                                >
                                  {dataProductSelect.filter(
                                    (i) => i.itemCode === item.itemCode
                                  ).length > 0
                                    ? "Đã chọn"
                                    : "Chọn"}
                                </Button>
                              </Table.Td>
                              <Table.Td w={100}>{item.itemCode}</Table.Td>
                              <Table.Td>{item.itemName}</Table.Td>
                            </Table.Tr>
                          ))
                        ) : (
                          <Table.Tr>
                            <Table.Td
                              colSpan={3}
                              ta={"center"}
                              fw={500}
                              h={350}
                              w={400}
                            >
                              {keySearch.length < 3
                                ? "Nhập ít nhất 3 kí tự để tìm kiếm !"
                                : "Không tìm thấy sản phẩm !"}
                            </Table.Td>
                          </Table.Tr>
                        )}
                      </Table.Tbody>
                    </Table>
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
              <Button
                leftSection={<IconDownload size={14} />}
                color="blue"
                variant="outline"
                component="a"
                href="/template/TemplateUploadPrVourcher.xlsx"
                download
                size="xs"
              >
                Tải file mẫu
              </Button>
              <FileButton
                resetRef={resetRef}
                disabled={
                  isEnable && Array.isArray(isEnable) && isEnable.length > 0
                }
                onChange={(file) => {
                  if (
                    file &&
                    (file.type ===
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                      file.type === "application/vnd.ms-excel")
                  ) {
                    handleFileUpload(file);
                  } else
                    NotificationExtension.Fails(
                      "File không đúng định đạng Excel !"
                    );
                  resetRef.current?.();
                }}
              >
                {(props) => (
                  <Button
                    leftSection={
                      <IconFileUpload
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                    disabled={isEnable}
                    size="xs"
                    {...props}
                  >
                    Import Excel
                  </Button>
                )}
              </FileButton>
              <Divider size="sm" orientation="vertical" />
              <Button
                variant="outline"
                color="red"
                leftSection={<IconDatabaseX size={14} />}
                size="xs"
                onClick={() => modalsDeleteAll()}
              >
                Xóa tất cả
              </Button>
            </Flex>
          </>
        ) : (
          <></>
        )}
      </>
    ),
    onRowSelectionChange: setRowSelection,
    rowCount: dataProductSelect.length,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "default",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  React.useEffect(() => {
    const newColumnVisibility = getColumnVisibility();
    if (table) {
      table.setColumnVisibility(newColumnVisibility);
    }
  }, [isDetail, table]);

  return (
    <>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default TableProduct;
